module.exports = __webpack_public_path__ + "img/benefits-thumb-2.475296f.png";